<template>
  <div>
    <router-view v-if="ready"></router-view>
    <p v-else>Loading 2...</p>
    <CToaster
      v-for="(toaster, toasterKey) in toasters"
      :position="toasterKey"
      :key="'toaster' + toasterKey"
    >
      <template v-for="(toast, key) in toaster">
        <CToast :key="'toast' + key" :show="true" v-bind="toast">
          {{ toast.text }}
        </CToast>
      </template>
    </CToaster>
    <v-tour
      name="newUserTour"
      :steps="newUserTourSteps"
      :callbacks="tourCallbacks"
    >
    </v-tour>
  </div>
</template>

<script>
import { setCulture } from "@syncfusion/ej2-base";
import { apiPatch } from "./helpers/apiHelper";

export default {
  name: "App",
  data() {
    return {
      ready: false,
    };
  },

  computed: {
    newUserTourSteps() {
      return [
        {
          target: "#tourRoleSelector",
          content: this.$t("family.dashboard.tour.roleSelector"),
          params: {
            placement: "bottom",
          },
        },
        {
          target: "#tourUserSettings",
          content: this.$t("family.dashboard.tour.tourUserSettings"),
          params: {
            placement: "right",
          },
        },
        {
          target: "#tourRoleSettingsMenu",
          content: this.$t("family.dashboard.tour.tourRoleSettingsMenu"),
          params: {
            placement: "right",
          },
        },
        {
          target: "#tourBuyMenu",
          content: this.$t("family.dashboard.tour.tourBuyMenu"),
          params: {
            placement: "right",
          },
        },
        {
          target: "#tourMarkets",
          content: this.$t("family.dashboard.tour.tourMarkets"),
          params: {
            placement: "top",
          },
          before: (type) =>
            new Promise((resolve) => {
              this.$router
                .push({
                  name: "UserMarketList",
                  params: {
                    id: this.$store.state.connections.current.family.id,
                  },
                })
                .then(() => {
                  setTimeout(resolve, 500);
                });
            }),
        },
      ];
    },
    tourCallbacks() {
      return {
        onFinish: this.onFinishTourCallback,
        onSkip: this.onFinishTourCallback,
      };
    },
    toasters() {
      let res = this.$store.state.toaster.toasts.reduce((toasters, toast) => {
        toasters[toast.position] = toasters[toast.position] || [];
        toasters[toast.position].push(toast);
        return toasters;
      }, {});
      return res;
    },
    user_lang() {
      var user_data = this.$auth.user() || { language: null };
      return user_data.language;
    },
  },
  created() {
    this.ready = true;
  },

  methods: {
    onFinishTourCallback() {
      this.$store.commit("set", ["hasCompletedTour", true]);
      this.updateUserTourStatus();

      if (this.$route.path !== "/dashboard") {
        this.$router.push("/dashboard").catch(() => {});
      }
    },

    async updateUserTourStatus() {
      const requestParams = {
        extra: {
          has_completed_tour: true,
        },
      };
      const response = await apiPatch("account_user", "", requestParams);
      if (response && response.status === 200) {
        this.$auth.user(response.data);
      } else {
        console.error("Unexpected response:", response);
      }
    },
  },

  watch: {
    user_lang: function (newLang, oldLang) {
      if (newLang && this.$i18n.locale !== newLang) {
        this.$i18n.locale = newLang;
        setCulture(newLang);
      }
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
